import { AdpEarningsCodeConditions, AdpEarningsDefinition, AdpEarningsField } from "@herbjoy/apex-api-models";
import { IComponentOptions, IFormController, IOnChanges, IOnChangesObject } from "angular";
import cloneDeep from "lodash/cloneDeep";
import { EventEmitter } from "../../../common/components/event-emitter";
import templateUrl from "./adp-earnings-code-editor.component.html";

export const AdpEarningsCodeEditorComponent: IComponentOptions = {
    templateUrl,
    bindings: {
        earningsDefinition: "<",
        changeDefinition: "&onChange"
    },
    require: {
        editForm: "^^form"
    },
    controller: class AdpEarningsCodeEditorComponent implements IOnChanges {
        //@Input
        earningsDefinition: AdpEarningsDefinition;
        //@Input
        editForm: IFormController;
        showConditions: boolean;
        changeDefinition: EventEmitter<{ definition: ValidAdpEarningsDefinition }>;
        model: ValidAdpEarningsDefinition;
        departments = [
            { value: "Dept100", text: "100 Owner" },
            { value: "Dept200", text: "200 Admins" },
            { value: "Dept400", text: "400 Sales" },
            { value: "Dept900", text: "900 1099" },
        ];

        specialRestrictions = [
            { value: "VolumeBonus", text: "VolumeBonus" },
        ];

        $onChanges(changesObj: IOnChangesObject) {
            if (changesObj.earningsDefinition) {
                this.earningsDefinition = {
                    ...this.earningsDefinition,
                    conditions: cloneDeep(this.earningsDefinition.conditions)
                }
            }
        }

        onChangeDefinition() {
            this.changeDefinition({
                $event: {
                    definition: createValidEarningsDefinition(this.earningsDefinition)
                }
            })
        }

        onAddCondition() {
            this.earningsDefinition.conditions.push({
                departments: []
            })
        }

        onRemoveCondition(condition: AdpEarningsCodeConditions) {
            this.earningsDefinition.conditions = this.earningsDefinition.conditions.filter(p => p !== condition);
            this.changeDefinition({
                $event: {
                    definition: createValidEarningsDefinition(this.earningsDefinition)
                }
            })
        }

        onChangePayHours({ field }: { field: AdpEarningsField }) {
            this.earningsDefinition.payHours = field;
            this.onChangeDefinition();
        }

        onChangePayRate({ field }: { field: AdpEarningsField }) {
            this.earningsDefinition.payRate = field;
            this.onChangeDefinition();
        }

        onChangeDollars({ field }: { field: AdpEarningsField }) {
            this.earningsDefinition.dollars = field;
            this.onChangeDefinition();
        }

        validate(): boolean {
            return this.editForm.$valid;
        }
    }
};

function createValidEarningsDefinition(definition: AdpEarningsDefinition): ValidAdpEarningsDefinition {
    return {
        conditions: definition.conditions,
        description: definition.description,
        earningsCode: definition.earningsCode,
        earningsCodeName: definition.earningsCodeName,
        earningsType: definition.earningsType,
        dollars: definition.dollars,
        payHours: definition.payHours,
        payRate: definition.payRate
    };
}

export interface ValidAdpEarningsDefinition {
    earningsCode: string | undefined;
    earningsCodeName?: string | undefined;
    earningsType?: string | undefined;
    description: string | undefined;
    conditions: AdpEarningsCodeConditions[] | undefined;
    payHours?: AdpEarningsField | undefined;
    dollars?: AdpEarningsField | undefined;
    payRate?: AdpEarningsField | undefined;
}
